import { atom } from "jotai";

export const forceIsDirtyAtom = atom(false);
